import ForgotPassword from 'components/ForgotPassword';
import { Layout } from 'components/Layout/Layout';
import withApollo from 'lib/apollo';
import { useUnauthenticatedOnlyRoute } from 'lib/hooks/useUnauthenticatedOnlyRoute';
import React from 'react';

function ForgotPasswordPage() {
  useUnauthenticatedOnlyRoute();
  return (
    <Layout title="Forgot Password">
      <ForgotPassword />
    </Layout>
  );
}

export default withApollo(ForgotPasswordPage, { ssr: false });
